/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var PersonTieRelationshipOutlineIcon = function PersonTieRelationshipOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C9.23858 4 7.00001 6.23858 7.00001 9C7.00001 11.7614 9.23858 14 12 14C14.7614 14 17 11.7614 17 9C17 6.23858 14.7614 4 12 4ZM9.00001 9C9.00001 7.34315 10.3432 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3432 12 9.00001 10.6569 9.00001 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.05486 19.6733C2.89643 17.2383 4.75391 15.2513 7.14699 14.0967L8.66525 15.6149C6.40163 16.4921 4.66952 18.2307 3.94515 20.3266L3.6185 21.2718L1.72821 20.6185L2.05486 19.6733Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15L11 17.5L10 21H14L13 17.5L14 15H10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16C21 17.1046 20.1046 18 19 18C17.8954 18 17 17.1046 17 16C17 14.8954 17.8954 14 19 14C20.1046 14 21 14.8954 21 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4817 20.8172C16.2266 19.705 17.5418 19 19 19C20.4582 19 21.7734 19.705 22.5184 20.8172C22.8516 21.3147 22.813 21.9047 22.5328 22.3375C22.2672 22.7476 21.8035 23 21.2982 23H16.7018C16.1965 23 15.7328 22.7476 15.4672 22.3375C15.187 21.9047 15.1484 21.3147 15.4817 20.8172Z"
  }));
};
export default PersonTieRelationshipOutlineIcon;